import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import _get from 'lodash/get';
import _isInteger from 'lodash/isInteger';
import { createSelector } from 'reselect';

import type { RootState } from '~/reducers';
import { MappedAccountStorefront } from '~/types/mappedResponseTypes';

export const getIsUserContextLoaded = (state: RootState): boolean => {
  return state.vendorAccount.isUserContextLoaded;
};

export const getIsAuthenticated = (state: RootState): boolean => {
  const { cognitoId } = state.vendorAccount;
  return getIsUserContextLoaded(state) && Boolean(cognitoId);
};

export const getIsIdTokenValid = (state: RootState): boolean => {
  const { idTokenExpiresAt } = state.vendorAccount;
  return _isInteger(idTokenExpiresAt) && Date.now() < (idTokenExpiresAt as number) * 1000;
};

export const getHasStorefront = (state: RootState): boolean => {
  const { currentStorefrontUuid } = state.vendorAccount;
  return getIsAuthenticated(state) && Boolean(currentStorefrontUuid);
};

export const getProfileOnboardedAt = (state: RootState): number | null => {
  const { profileOnboardedAt } = state.vendorAccount;
  return profileOnboardedAt;
};

export const getAccountEmail = (state: RootState): string | null => {
  const { email } = state.vendorAccount;
  return email;
};

export const getAccountUserUuid = (state: RootState): string | null => {
  const { userUuid } = state.vendorAccount;
  return userUuid;
};

export const getCurrentStorefront = (state: RootState): MappedAccountStorefront | undefined => {
  const { currentStorefrontUuid, storefronts } = state.vendorAccount;
  return storefronts.find((storefront) => storefront.uuid === currentStorefrontUuid);
};

export const getCurrentStorefrontUuid = (state: RootState): string | null => {
  const storefront = getCurrentStorefront(state);
  return storefront ? storefront.uuid : null;
};

export const getCurrentStorefrontId = (state: RootState): number | null => {
  const { currentStorefrontUuid, storefronts } = state.vendorAccount;
  const currentStorefront = storefronts.find(
    (storefront) => storefront.uuid === currentStorefrontUuid
  );
  return _get(currentStorefront, 'id', null);
};

export const getCurrentStorefrontTaxonomyKey = (state: RootState): VendorTaxonomyKey | null => {
  const storefront = getCurrentStorefront(state);
  return storefront?.taxonomyKey || null;
};

export const getStorefronts = (state: RootState): MappedAccountStorefront[] =>
  state.vendorAccount.storefronts;

export const getCompanyUuid = createSelector(getStorefronts, (storefronts) => {
  return (storefronts && storefronts.length > 0 && storefronts[0].companyUuid) || null;
});

export const getError = (state: RootState): Error | null => state.vendorAccount.error;
